import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import EventsStore from '../stores/EventsStore'
import LoadingWrapper from '../components/LoadingWrapper'
import { Divider, Grid, Header, List } from 'semantic-ui-react'
import moment from 'moment'
import FormIndex from '../components/Events/Forms/FormIndex'

@withRouter
@observer
class PrintScreen extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    const { match, history } = props
    if (!match.params.eventId || !match.params.jwt) {
      history.goBack()
    }
    this.eventStore = new EventsStore()
    this.eventStore.loadFormArchiveWithJwt(match.params.jwt, match.params.eventId).then(() => {
      this.setState({}, () => {
        if (window.pageReady) {
          setTimeout(() => {
            window.pageReady()
          }, 1000)
        }
      })
    })
  }

  changeMenuType = () => {}

  render () {
    const { isLoading, event, forms } = this.eventStore
    let lastForm = null
    if (isLoading) {
      return <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
    }
    return (
      <>
        {!!event &&
          <>
            <Grid columns={2}>
              <Grid.Row>
                <Grid.Column>
                  <Header
                    as='h1'
                    content={`Rapport d'inspection - ${event.clients_addresses_equipment.equipment.name}`}
                  />
                </Grid.Column>
                <Grid.Column textAlign='right'>
                  <List>
                    <List.Item>
                      {event.client.name}
                    </List.Item>
                    <List.Item>
                      {event.clients_addresses_equipment.clients_address.address.fullAddress}
                    </List.Item>
                    <List.Item>
                      {moment(event.date_start).format('HH:mm DD-MM-YYYY')}
                    </List.Item>
                  </List>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {event.forms_entries.map(
              (formEntry, index) => {
                /** @var {Form} */
                const currentForm = forms.find(form => form.id === formEntry.form_id)
                if (!currentForm || !currentForm.code) {
                  return <Fragment key={`formEntry_${formEntry.id}`} />
                }
                let showTitle = false
                const Element = FormIndex[forms.find(form => form.id === formEntry.form_id).code.replaceAll('-', '')]
                if (lastForm !== currentForm) {
                  lastForm = currentForm
                  showTitle = true
                }
                return (
                  <div key={`formEntry_${formEntry.id}`} className='html2pdf__page-break'>
                    {!!index && <Divider />}
                    {showTitle && <Header as='h1'>{currentForm.name}</Header>}
                    <Element equipment={formEntry} changeMenuType={this.changeMenuType} isPrint />
                  </div>
                )
              })}
          </>}
      </>
    )
  }
}

export default PrintScreen
